import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=176b7a09&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=176b7a09&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176b7a09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('176b7a09')) {
      api.createRecord('176b7a09', component.options)
    } else {
      api.reload('176b7a09', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=176b7a09&scoped=true", function () {
      api.rerender('176b7a09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/Product.vue"
export default component.exports